import cx from 'classnames'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import { Icon as IconType } from 'blaze-ui/icons/Types'
import Styles from 'components/FirstTimeExperienceModal/steps/BrandPlanCurrentVolume/Social.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { Account } from 'screens/BrandKit/SourceMaterials/SourceCreationModal/Account'

import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { useRootStore } from 'stores/RootStore'
import { SettingsDrawer } from './SettingsDrawer/SettingsDrawer'
import { Settings } from 'blaze-ui/icons'
import { useDeleteExternalIntegration } from 'hooks/queries/externalIntegrations/useDeleteExternalIntegration'

interface IntegrationAccountRowProps {
  integration: ExternalIntegration
  icon: IconType
  name: string
}

export const IntegrationAccountRow = ({ integration, icon: Icon, name }: IntegrationAccountRowProps) => {
  const { drawersStore } = useRootStore()
  const { mutate } = useDeleteExternalIntegration(integration.id)

  const openSettingsDrawer = () => {
    drawersStore.openDrawer(SettingsDrawer, {
      onDelete: async () => {
        mutate()
        drawersStore.closeDrawer()
      },
    })
  }

  return (
    <>
      <ResponsiveDesign.Desktop>
        <div className={Styles.row}>
          <div className={Styles.rowTitle}>
            <Icon size={24} />
            <Text variant="largeList">{name}</Text>
          </div>
          <div className={Styles.account}>
            <Account source={integration} avatarSize={32} />
          </div>
        </div>
      </ResponsiveDesign.Desktop>
      <ResponsiveDesign.Mobile>
        <div className={cx(Styles.row, Styles.withAccount)}>
          <div className={Styles.account}>
            <Account source={integration} avatarSize={32} />
          </div>
          <div className={Styles.connectedContainer}>
            <div className={Styles.checkIconContainer}>
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path
                  d="M2 6.41176C2.79279 6.96078 4.37838 8.47059 5.02703 9.5C5.81982 7.85294 7.83784 4.14706 10 2.5"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className={Styles.connectedTextContainer}>
              <Text color="var(--green-50)" variant="smallList">
                Connected
              </Text>
              <IconButton variant="editor" icon={Settings} onPress={openSettingsDrawer} />
            </div>
          </div>
        </div>
      </ResponsiveDesign.Mobile>
    </>
  )
}
